export const YouthByMBRowKey = {
  getKey({
    memberId,
    meritBadgeId,
  }: {
    memberId: number;
    meritBadgeId: number;
  }): string {
    return `${meritBadgeId}:${memberId}`;
  },
  parseKey(key: string) {
    const [meritBadgeId, memberId] = key.split(':');

    return {
      meritBadgeId: +meritBadgeId,
      memberId: +memberId,
    };
  },
};
export const ToApproveRowKeys = {
  getRequirementKey(params: {
    meritBadgeId: number;
    requirementId: number;
    memberId: number;
  }): string {
    return `${params.meritBadgeId}:${params.requirementId}:${params.memberId}`;
  },
  parseRequirementKey(key: string) {
    const [meritBadgeId, requirementId, memberId] = key.split(':');

    return {
      requirementId: +requirementId,
      meritBadgeId: +meritBadgeId,
      memberId: +memberId,
    };
  },
};

type PersonName = {
  firstName?: string | null;
  lastName?: string | null;
  nickName?: string | null;
};

const getDisplayFirstName = ({ nickName, firstName }: PersonName) =>
  nickName || firstName || '';

export type NameSortField = 'firstName' | 'lastName';

const compareFirstNames = (a: PersonName, b: PersonName) =>
  getDisplayFirstName(a).localeCompare(getDisplayFirstName(b));

const compareLastNames = (a: PersonName, b: PersonName) =>
  (a.lastName ?? '').localeCompare(b.lastName ?? '');

export const compareByName = (
  a: PersonName,
  b: PersonName,
  sortBy: NameSortField = 'lastName',
) =>
  sortBy === 'firstName'
    ? compareFirstNames(a, b) || compareLastNames(a, b)
    : compareLastNames(a, b) || compareFirstNames(a, b);
